export default {
    colors: {
        primary: '#F7B731',
        secondary: '#4900F6'
    },
    overrideFunction: ({ colors }) => ({
        h1BorderColor: colors.primary,
        h2BorderColor: colors.primary,
        colorLink: colors.secondary,
        subNavBg: colors.secondary,
        subNavMobileBackgroundColor: colors.secondary,
        partnerOfferMain: colors.primary,
        partnerCardMainDiscountColor: colors.primary,
        howItWorkBlockBoldColor: colors.primary,
        faqLinkTextColor: colors.black,
        hrBackgroundColor: colors.primary,

        buttonMainBg: colors.secondary,
        buttonMainText: colors.white,
        buttonMainBorder: colors.secondary,
        buttonMainHoverBg: colors.secondary,
        buttonMainHoverText: colors.white,
        buttonMainHoverBorder: colors.secondary
    })
};



// WEBPACK FOOTER //
// ./src/style/applicationSpecific/oriwayTheme.js